import { UTEST_AVENUE_API } from "../../../constants/apiConstants";

const axios = require('axios').default;

export async function GetCharge(id) {
    try {
        const res = await axios({
            method: 'get',
            url: `${UTEST_AVENUE_API}/omise/charges/${id}`
        });

        return {
            success: true,
            res: res.data
        }

    } catch (err) {
        console.log(err);

        return {
            success: false,
            res: err
        }
    }
}

export async function GetSource(sourceId) {
    try {
        const res = await axios({
            method: 'get',
            url: `${UTEST_AVENUE_API}/omise/sources/${sourceId}`
        });

        return {
            success: true,
            res: res.data
        }

    } catch (err) {
        console.log(err);

        return {
            success: false,
            res: err
        }
    }
}

export async function GetQRCode(amount) {
    try {
        const res = await axios({
            method: 'get',
            url: `${UTEST_AVENUE_API}/omise/promptpay/qr/amount/${amount}`
        });

        return {
            success: true,
            res: res.data
        }

    } catch (err) {
        console.log(err);

        return {
            success: false,
            res: err
        }
    }
}